// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1z-PI","label":"Category_label__psez7","content":"Category_content__36azJ","header":"Category_header__16uZ-","location":"Category_location__2u74q"};